"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _ = require("../..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var styles = function styles(theme) {
  return {
    formControl: {
      margin: 0,
      fullWidth: true,
      display: 'flex',
      wrap: 'nowrap'
    }
  };
};

var Dropdown = function Dropdown(_ref) {
  var label = _ref.label,
      value = _ref.value,
      options = _ref.options,
      handleSelection = _ref.handleSelection,
      renderItem = _ref.renderItem,
      hasSearch = _ref.hasSearch,
      search = _ref.search,
      onSearch = _ref.onSearch,
      props = _objectWithoutProperties(_ref, ["label", "value", "options", "handleSelection", "renderItem", "hasSearch", "search", "onSearch"]);

  var renderDropdownItem = function renderDropdownItem(option) {
    if (renderItem) {
      return renderItem(option);
    }

    return option;
  };

  var textStyles = {
    marginLeft: '16px'
  };

  if (!search) {
    textStyles.textAlign = 'right';
  }

  return _react["default"].createElement(_core.FormControl, {
    className: props.classes.formControl
  }, label && _react["default"].createElement(_.Typography, {
    type: "meta"
  }, label), _react["default"].createElement(_core.Select, {
    value: value,
    onChange: function onChange(event) {
      return handleSelection(event.target.value);
    },
    style: {
      minWidth: 120,
      border: '1px solid #D7DAE2',
      borderRadius: 2,
      padding: 6
    },
    disableUnderline: true,
    autoWidth: true,
    renderValue: renderItem
  }, hasSearch ? _react["default"].createElement("div", null, _react["default"].createElement(_.TextInput, {
    style: textStyles,
    placeholder: "\uD83D\uDD0D",
    value: search,
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    onKeyDown: function onKeyDown(e) {
      e.stopPropagation();
    },
    onChange: function onChange(e) {
      return onSearch(e.target.value);
    }
  })) : null, options.map(function (option, index) {
    return _react["default"].createElement(_core.MenuItem, {
      key: index,
      value: option
    }, renderDropdownItem(option));
  })));
};

Dropdown.propTypes = {
  label: _propTypes["default"].string,
  value: _propTypes["default"].any,
  options: _propTypes["default"].array,
  handleSelection: _propTypes["default"].func,
  hasSearch: _propTypes["default"].bool,
  search: _propTypes["default"].string,
  onSearch: _propTypes["default"].func,
  renderItem: _propTypes["default"].func
};

var _default = (0, _styles.withStyles)(styles)(Dropdown);

exports["default"] = _default;